import { messages } from "i18n/messages";

export const ENGLISH = "en";
export const POLISH = "pl";

export function translate(language, key, params) {
    if (key == null || key === "") {
        return "";
    }
    const dictionary = messages[language] || messages[ENGLISH];
    const template = Object.prototype.hasOwnProperty.call(dictionary, key)
        ? dictionary[key]
        : messages[ENGLISH][key];
    if (template == null) {
        return String(key);
    }
    if (!params) {
        return template;
    }
    return template.replace(/\{(\w+)\}/g, (_, name) => (
        params[name] == null ? "" : String(params[name])
    ));
}

export function textForCode(t, value) {
    if (value == null || value === "") {
        return "—";
    }
    const key = `code.${String(value).toLowerCase()}`;
    const translated = t(key);
    if (translated !== key) {
        return translated;
    }
    return String(value)
        .toLowerCase()
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}
